let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2BYQO")).then(() => parcelRequire('d0tEQ'));